export default "__VITE_ASSET__DDZV6_Lb__"